<div class="visual-dashboard-widget-wrapper" [style.--state-background]="backgroundColor()" [style.--state-accent]="borderColor()">
    <div class="header">
        <h3>{{ titleTranslationKey() | translate }}</h3>
        @if (isEditMode()) {
            <div class="action-buttons-row">
                <button
                    class="button linkLike"
                    type="button"
                    (click)="handleEditWidget()"
                    (mousedown)="$event.stopPropagation()"
                    (touchstart)="$event.stopPropagation()"
                >
                    <i class="far fa-edit"></i>
                </button>
                <button
                    class="button danger"
                    type="button"
                    (click)="handleRemoveWidget()"
                    (mousedown)="$event.stopPropagation()"
                    (touchstart)="$event.stopPropagation()"
                >
                    <i class="far fa-trash"></i>
                </button>
            </div>
        } @else {
            <div class="non-edit-header-actions">
                @if (showPeriodPicker()) {
                    <app-visuals-dashboard-period-picker
                        [selectedOptionValue]="widget().selectedPeriodOptionValue"
                        (periodChange)="onPeriodChange($event)"
                        [showLabel]="false"
                    ></app-visuals-dashboard-period-picker>
                }
                @if (showDistributorDropdown()) {
                    <app-visuals-dashboard-distributor-picker
                        [selectedOptionValue]="selectedDistributorId()"
                        [options]="availableDistributors()"
                        (distributorChange)="onDistributorChange($event)"
                    ></app-visuals-dashboard-distributor-picker>
                }
                @if (widget().translatedFullDescription) {
                    <i
                        appTooltip
                        class="far fa-info-circle"
                        trigger="hover"
                        position="right"
                        [showDelay]="100"
                        [hideDelay]="100"
                        [tooltipTextWidthCharacters]="60"
                        [displayHtmlContent]="true"
                        [componentData]="widget().translatedFullDescription"
                    ></i>
                }
            </div>
        }
    </div>
    <div class="content">
        <ng-container *ngComponentOutlet="widget().component; inputs: widgetInputs()" />
    </div>
</div>
